import { FormattedMessage, useIntl } from 'react-intl';
import { useParams } from 'react-router';
import styles from './DownloadElement.module.scss';
import { dayjs, dayjsWithTimezone } from 'utils';
import { Icon, Button } from '@ets/design-system';
import { PublicLinkInfo, useDownloadPublicLinkFileMutation } from '../PublicLinkPageApi';

const DownloadElement = ({ data }: { data: PublicLinkInfo }) => {
  const intl = useIntl();
  const { hash } = useParams<{ hash: string }>();
  const [downloadPublicLinkFile] = useDownloadPublicLinkFileMutation();
  const expirationDate = dayjsWithTimezone(
    data?.link?.expiration.expiration,
    dayjs.tz.guess() as Timezone,
  )
    .hour(23)
    .minute(55);

  const handleDownload = () => {
    downloadPublicLinkFile({
      filename: data.object ? data.object.name : '',
      hash,
      password: data.password,
    });
  };

  return (
    <div className={styles.container}>
      <div className={styles.logoContainer}>
        <Icon size="20" icon="file" color="primary" testId="file" />
      </div>
      <div className={styles.title}>
        {data?.object?.name}
        <br />
        <div className={styles.text} data-testid="public-link-expiration-date">
          {data?.link?.expiration.expiration &&
            data.link.expiration.active &&
            `${intl.formatMessage({ id: 'public.willExpire' })}
              ${expirationDate.from(dayjs())}`}
        </div>
      </div>

      <Button variant="primary" onClick={handleDownload} testId="public-link-download" size="m">
        <FormattedMessage id="public.downloadFile" />
      </Button>
    </div>
  );
};

export default DownloadElement;
